import clsx from 'clsx';

import { useView } from '@/hooks';

type Props = {
  // A standalone page renders with no app layout around it (the signed-out
  // /support route), so it must supply its own viewport height. Without it
  // the iframe collapses to the browser default of 150px.
  standalone?: boolean;
};

const Support = ({ standalone = false }: Props) => {
  const { isClient } = useView();

  return (
    <div
      className={clsx('flex flex-1 flex-col', {
        'bg-sage-100': !isClient,
        'bg-sunny-100': isClient,
        'h-dvh': standalone,
      })}
    >
      <iframe
        className="flex-1 border-0"
        sandbox="allow-same-origin"
        src="https://resources.mento.co/mento-member-faq"
        title="Support"
      />
    </div>
  );
};

export default Support;
